module.exports = "//static.hsappstatic.net/pricing-pages-ui-components/static-1.13971/js/hsocImages/carousel_sales_prospecting_agent.svg"